import * as React from 'react';

function SvgPayoutOppsInfo(props) {
  return (
    <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M10.929 8.949a1.643 1.643 0 100 3.286 1.643 1.643 0 000-3.286zm0 2.25a.607.607 0 11-.001-1.214.607.607 0 010 1.214zm3.643-9.34h-3.786a1 1 0 00-1-1H8.357a1 1 0 00-1 1H3.572A.57.57 0 003 2.431v3.571H1.43a.57.57 0 00-.572.572v8a.57.57 0 00.572.571h6A.57.57 0 008 14.574v-.286h6.572a.57.57 0 00.571-.572V2.431a.57.57 0 00-.571-.572zM7.215 3.002H8.5v-1h1.143v1h1.286v.857H7.215v-.857zm-.358 11H2V9.86h4.857v4.143zm0-5.286H2V7.145h4.857v1.571zm7 4.286H8V6.574a.57.57 0 00-.571-.572H4.286V3.145h1.786v1.857h6V3.145h1.785v9.857zM11.43 6.145v1.714c0 .079.064.143.143.143h.857a.143.143 0 00.143-.143V6.145a.143.143 0 00-.143-.143h-.857a.143.143 0 00-.143.143zm-2 1.857h.857a.143.143 0 00.143-.143v-1a.143.143 0 00-.143-.143h-.857a.143.143 0 00-.143.143v1c0 .079.064.143.143.143z"
        fill="#38B2A6"
      />
    </svg>
  );
}

export default SvgPayoutOppsInfo;
